import { Link as RouterLink } from 'react-router-dom';
import { Box, BoxProps } from '@rossum/ui/material';

const StyledLink = (
  props: BoxProps<typeof RouterLink> & { disabled?: boolean }
) => (
  <Box
    component={RouterLink}
    {...props}
    sx={{
      color: theme => theme.palette.secondary.main,
      textDecoration: 'none',
      '&:hover': {
        color: theme => theme.palette.secondary.light,
        textDecoration: !props.disabled ? 'underline' : 'none',
      },
      ...props.sx,
    }}
  />
);

export { StyledLink };
